// extracted by mini-css-extract-plugin
export default {"wrapper":"OverviewChartCard_wrapper__9ZSjt","chartTypeSwitcher":"OverviewChartCard_chartTypeSwitcher__GeHq2"};